import React from "react";

export function LaunchMonitorIcon({ active }: any) {
  const color = active ? "#ffffff" : "#000000";

  return (
    <svg
      width="13"
      height="20"
      viewBox="0 0 13 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.53846 12.0769C9.59727 12.0769 12.0769 9.59727 12.0769 6.53846C12.0769 3.47965 9.59727 1 6.53846 1C3.47965 1 1 3.47965 1 6.53846C1 9.59727 3.47965 12.0769 6.53846 12.0769Z"
        stroke={color}
        stroke-width="1.38462"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.06934 12.769C2.52318 14.0844 4.46164 14.846 6.53857 14.846C8.61549 14.846 10.554 14.0844 12.0078 12.769"
        stroke={color}
        stroke-width="1.38462"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.53857 19V14.8462"
        stroke={color}
        stroke-width="1.38462"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.02312 6.74635C7.02312 6.74635 6.95388 6.67712 6.88465 6.67712C6.88465 6.67712 6.81542 6.60789 6.74619 6.60789C6.67696 6.60789 6.67696 6.60789 6.60773 6.53866C6.40004 6.46943 6.12311 6.53866 5.98465 6.74635C5.91542 6.88481 5.84619 7.02327 5.84619 7.23096C5.84619 7.43866 5.91542 7.57712 6.05388 7.71558C6.19235 7.85404 6.33081 7.92327 6.5385 7.92327C6.60773 7.92327 6.74619 7.92327 6.81542 7.85404C6.88465 7.78481 6.95388 7.78481 7.02312 7.71558C7.16158 7.57712 7.23081 7.43866 7.23081 7.23096C7.23081 7.02327 7.16158 6.88481 7.02312 6.74635Z"
        fill={color}
      />
      <path
        d="M4.25407 6.74635C4.25407 6.74635 4.18484 6.67712 4.11561 6.67712C4.11561 6.67712 4.04638 6.60789 3.97715 6.60789C3.90792 6.60789 3.90792 6.60789 3.83869 6.53866C3.63099 6.46943 3.35407 6.53866 3.21561 6.74635C3.14638 6.88481 3.07715 7.02327 3.07715 7.23096C3.07715 7.43866 3.14638 7.57712 3.28484 7.71558C3.4233 7.85404 3.56176 7.92327 3.76946 7.92327C3.83869 7.92327 3.97715 7.92327 4.04638 7.85404C4.11561 7.78481 4.18484 7.78481 4.25407 7.71558C4.39253 7.57712 4.46176 7.43866 4.46176 7.23096C4.46176 7.02327 4.39253 6.88481 4.25407 6.74635Z"
        fill={color}
      />
      <path
        d="M5.63884 8.82301C5.63884 8.82301 5.56961 8.75378 5.50038 8.75378C5.50038 8.75378 5.43114 8.68455 5.36191 8.68455C5.29268 8.68455 5.29268 8.68455 5.22345 8.61532C5.01576 8.54609 4.73884 8.61532 4.60038 8.82301C4.53114 8.96147 4.46191 9.09993 4.46191 9.30762C4.46191 9.51532 4.53114 9.65378 4.66961 9.79224C4.80807 9.9307 4.94653 9.99993 5.15422 9.99993C5.22345 9.99993 5.36191 9.99993 5.43114 9.9307C5.50038 9.86147 5.56961 9.86147 5.63884 9.79224C5.7773 9.65378 5.84653 9.51532 5.84653 9.30762C5.84653 9.09993 5.7773 8.96147 5.63884 8.82301Z"
        fill={color}
      />
      <path
        d="M8.40788 8.82301C8.40788 8.82301 8.33865 8.75378 8.26942 8.75378C8.26942 8.75378 8.20019 8.68455 8.13096 8.68455C8.06173 8.68455 8.06173 8.68455 7.9925 8.61532C7.7848 8.54609 7.50788 8.61532 7.36942 8.82301C7.30019 8.96147 7.23096 9.09993 7.23096 9.30762C7.23096 9.51532 7.30019 9.65378 7.43865 9.79224C7.57711 9.9307 7.71557 9.99993 7.92326 9.99993C7.9925 9.99993 8.13096 9.99993 8.20019 9.9307C8.26942 9.86147 8.33865 9.86147 8.40788 9.79224C8.54634 9.65378 8.61557 9.51532 8.61557 9.30762C8.61557 9.09993 8.54634 8.96147 8.40788 8.82301Z"
        fill={color}
      />
      <path
        d="M9.79265 6.74635C9.79265 6.74635 9.72341 6.67712 9.65418 6.67712C9.65418 6.67712 9.58495 6.60789 9.51572 6.60789C9.44649 6.60789 9.44649 6.60789 9.37726 6.53866C9.16957 6.46943 8.89265 6.53866 8.75418 6.74635C8.68495 6.88481 8.61572 7.02327 8.61572 7.23096C8.61572 7.43866 8.68495 7.57712 8.82341 7.71558C8.96188 7.85404 9.10034 7.92327 9.30803 7.92327C9.37726 7.92327 9.51572 7.92327 9.58495 7.85404C9.65418 7.78481 9.72342 7.78481 9.79265 7.71558C9.93111 7.57712 10.0003 7.43866 10.0003 7.23096C10.0003 7.02327 9.93111 6.88481 9.79265 6.74635Z"
        fill={color}
      />
    </svg>
  );
}
